import { render, staticRenderFns } from "./QuickRegister.vue?vue&type=template&id=89ef5980&scoped=true&"
import script from "./QuickRegister.vue?vue&type=script&lang=js&"
export * from "./QuickRegister.vue?vue&type=script&lang=js&"
import style0 from "./QuickRegister.vue?vue&type=style&index=0&id=89ef5980&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ef5980",
  null
  
)

export default component.exports